/**
 * Convert ReplayGain dB to linear gain, clamped by peak.
 *
 * `preampDb` is makeup gain added on top of the track's ReplayGain — the target
 * (-18 LUFS) attenuates most modern masters, so a positive preamp brings overall
 * level back up. The peak clamp still runs after the preamp, so loud tracks never
 * clip. Tracks without ReplayGain data are passed through at unity (no preamp),
 * since we have no peak to clamp a boost against.
 */
export function replayGainToLinear(
  gainDb: number | null | undefined,
  peak: number | null | undefined,
  preampDb = 0
): number {
  if (gainDb == null) return 1.0
  let gain = 10 ** ((gainDb + preampDb) / 20)
  if (peak != null && peak > 0 && peak * gain > 1.0) {
    gain = 1.0 / peak
  }
  return gain
}
